import React from "react";
import pmAward from "../../assets/awards/prime_minister_award.png";
import skochSilver from "../../assets/awards/skoch_silver_award.png";
import googleForStartup from "../../assets/google_for_startup.png";

const items = [
  {
    src: pmAward,
    alt: "Prime Minister's Award",
    label: "PM's Award",
    sub: "Excellence in Education",
  },
  {
    src: skochSilver,
    alt: "SKOCH Silver Award",
    label: "SKOCH Silver",
    sub: "EdTech Impact",
  },
  {
    src: googleForStartup,
    alt: "Google for Startups",
    label: "Google for Startups",
    sub: "Backed",
  },
];

const TrustStrip = () => {
  return (
    <section
      aria-label="Awards and recognition"
      className="bg-white border-y border-gray-200"
    >
      <div className="max-w-6xl mx-auto px-4 py-6 flex flex-wrap justify-center items-center gap-x-8 gap-y-6">
        <div className="flex items-center gap-3">
          <div className="text-yellow-500 text-2xl leading-none" aria-hidden>
            ★★★★★
          </div>
          <div>
            <p className="font-bold text-gray-900 leading-tight">4.5 / 5</p>
            <p className="text-xs text-gray-500 leading-tight">
              Google Play Store
            </p>
          </div>
        </div>

        <div className="hidden sm:block w-px h-10 bg-gray-200" />

        {items.map((it) => (
          <div key={it.label} className="flex items-center gap-3">
            <img
              src={it.src}
              alt={it.alt}
              className="h-12 w-auto object-contain"
              loading="lazy"
            />
            <div>
              <p className="font-bold text-gray-900 leading-tight">
                {it.label}
              </p>
              <p className="text-xs text-gray-500 leading-tight">{it.sub}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default TrustStrip;
